import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import Modal from "react-modal";
import { BrowserRouter } from "react-router-dom";

import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { persistor, store } from "./shared/index.js";
import { setOrderNotification } from "./shared/slice/order/OrderSlice.js";
// CONFIGURATION LOGROCKET AMÉLIORÉE
import LogRocket from "logrocket";
import setupLogRocketReact from "logrocket-react";
import { SocketProvider } from "./utils/socketContext.js";
// 1. Initialisation avec protection des données sensibles
window.addEventListener('load', () => {
  console.log('🔥 DOM LOADED', window.location.hostname);
  if (typeof LogRocket !== 'undefined') {
    console.log('🚀 LogRocket existe !');
  } else {
    console.warn('❌ LogRocket NON chargé');
  }
});

LogRocket.init("kypsla/eatorder", {
   rootHostname: ".eatorder.fr",
  dom: {
    inputSanitizer: (input) => {
      const sensitiveFields = ['password', 'creditcard', 'cvv', 'cardnumber'];
      const isSensitive = sensitiveFields.some(field =>
        (input.name || "").toLowerCase().includes(field) ||
        (input.id || "").toLowerCase().includes(field) ||
        (input.className || "").toLowerCase().includes(field) ||
        (input.placeholder || "").toLowerCase().includes(field)
      );
      return isSensitive ? "*****" : input.value;
    },
    isEnabled: true,
    textSanitizer: (text) => {
      // Masquer les données sensibles dans le texte
      const regexPatterns = {
        email: /\b[\w.-]+@[\w.-]+\.\w{2,}\b/g,
        phone: /(\+?\d{1,3}[- ]?)?\(?\d{3}\)?[- ]?\d{3}[- ]?\d{4}\b/g
      };
      
      let sanitizedText = text;
      for (const [type, regex] of Object.entries(regexPatterns)) {
        sanitizedText = sanitizedText.replace(regex, `[${type} redacted]`);
      }
      return sanitizedText;
    }
  },
  network: {
    requestSanitizer: (request) => {
      // Exemple: Masquer le body des requêtes vers /api/auth
      if (request.url.includes('/api/auth')) {
        request.body = '[Redacted auth data]';
      }
      return request;
    },
    responseSanitizer: (response) => {
      // Masquer les tokens dans les réponses
      if (response.headers['authorization']) {
        response.headers['authorization'] = '[Redacted]';
      }
      return response;
    }
  },
  console: {
    isEnabled: true, // Enregistrer les logs console
    shouldAggregateConsoleErrors: true
  }
});

// 2. Intégration avec React
setupLogRocketReact(LogRocket);

// 3. Intégration avec Redux
LogRocket.reduxMiddleware(store);

// 4. Identification utilisateur (à appeler après l'authentification)
export const identifyUser = (user) => {
  LogRocket.identify(user.id, {
    name: user.name,
    email: user.email,
    role: user.role,
    subscription: user.subscriptionType,
    // Ajoutez d'autres propriétés utiles
  });
};

// import { ClearCacheProvider, useClearCacheCtx } from 'react-clear-cache';
// import { StrictMode } from 'react';
Modal.setAppElement("#root");
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    registrations.forEach((registration) => registration.unregister());
    // console.log("Old service workers unregistered.");
  });
}
if ('serviceWorker' in navigator) {
navigator.serviceWorker.addEventListener('message', (event) => {
  if (event.data.type === 'ORDER_NOTIFICATION') {
  

      const aa = event.data.payload
    
      const bb = aa.orderInfo
  

     store.dispatch(setOrderNotification({ OrderNotification: bb }));
  }
});
}
// Register the Firebase service worker
if ('serviceWorker' in navigator) {
  navigator.serviceWorker
  
    .register(`${process.env.PUBLIC_URL}/firebase-messaging-sw.js`)
    .then((registration) => {
      console.log('Service Worker registered with scope:', registration.scope);
    })
    .catch((error) => {
      console.error('Service Worker registration failed:', error);
    });
}
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  
  <Provider store={store}>
    {/* <ClearCacheProvider duration={5000}> */}

    <PersistGate persistor={persistor}>
      {/* <React.StrictMode> */}
      {/* <StrictMode> */}
      <SocketProvider> 
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </SocketProvider> 
      {/* </StrictMode> */}
      {/* </React.StrictMode> */}
    </PersistGate>
    {/* </ClearCacheProvider> */}
  </Provider>
);
// SUIVI DES PERFORMANCES
reportWebVitals((metrics) => {
  const logData = {
    name: metrics.name,
    value: metrics.value
  };
  if (metrics.rating !== undefined) {
    logData.rating = metrics.rating;
  }

  LogRocket.track('Web Vitals', logData);
});

reportWebVitals();

